import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Header from "../components/Header";
const { decryptPayload} = require("../utils/custom-hash");

function ConfirmCode() {
    const location = useLocation();
    const navigate = useNavigate();
    const [referenceCode, setReferenceCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [open, setOpen] = useState(false);
    const { branchDetails } = location.state || {};
    const branchId = branchDetails?.branchId;

    const handleSubmit = async () => {
        if (referenceCode.trim() === "") {
            setErrorMessage("Please enter a confirmation code.");
            setOpen(true);
            return;
        }

        try {
            const response = await fetch(
                `${process.env.REACT_APP_ASERVER}/api/kiosk/appointment/${branchId}/${referenceCode}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                setErrorMessage(data.message || "An error occurred while fetching the confirmation code.");
                setOpen(true);
            } else if (data.appointment.status === "Cancelled") {
                setErrorMessage("Entered confirmation code appointment is cancelled");
                setOpen(true);
                setReferenceCode("");
            } else {
                navigate("/print", {
                    state: { responseData: decryptPayload(data.appointment) },
                });
            }
        } catch (error) {
            setErrorMessage("Error fetching confirmation code: " + error.message);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancel = () => {
        setReferenceCode("");
        navigate("/");
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                backgroundColor: "#f2f2f2", // Same background color as PrintReceipt
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header />
            <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
      >
            <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={6}  mt={10}>
                    <Card
                      sx={{
                        borderRadius: 2,
                        boxShadow: 0,
                        backgroundColor: "#ffffff",
                        p: 5,
                     
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '2px solid #e0e0e0',
                      }}
                    >
                        <Typography variant="h5" fontWeight="bold" mb={2}>
                            Appointment Confirmation Code
                        </Typography>
                        <TextField
                            name="referenceCode"
                            label="Enter Confirmation Code"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputProps={{
                                style: {
                                    borderRadius: 4,
                                },
                            }}
                            InputLabelProps={{
                                sx: {
                                    color: "#333",
                                    "&.Mui-focused": {
                                        color: "#1877f2",
                                    },
                                },
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "#ddd",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#ccc",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#1877f2",
                                    },
                                },
                                mb: 1,
                            }}
                            value={referenceCode}
                            onChange={(e) => setReferenceCode(e.target.value)}
                            error={!!errorMessage}
                            helperText={errorMessage}
                        />
                    <Box mt={2} display="flex" justifyContent="space-between">
                            <Button
                                variant="outlined"
                                sx={{
                                    borderColor: '#1877f2',
                                    color: '#1877f2',
                                    borderRadius: 2,
                                    height: 50,
                                    width: '48%',
                                    "&:hover": {
                                        borderColor: '#0056b3',
                                    },
                                }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#1877f2',
                                    color: 'white',
                                    borderRadius: 2,
                                    height: 50,
                                    width: '48%',
                                    "&:hover": {
                                        backgroundColor: '#0056b3',
                                    },
                                }}
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Box>    
                    </Card>
                    
                </Grid>
            </Grid>
            </Box>

            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                PaperProps={{ sx: { borderRadius: 2, p: 3, boxShadow: 3 } }}
            >
                <DialogTitle>
                    <Box display="flex" justifyContent="center" mb={2}>
                        <ErrorOutlineIcon style={{ color: 'red', fontSize: 40 }} />
                    </Box>
                    <Typography variant="h6" align="center">
                        Error
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" align="center">
                        {errorMessage}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default ConfirmCode;
